import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { amazonPPKpisIsEmpty } from "../@signals";


export default function useAmazonPPKpisFilters() {

    const data = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${WEBBACK_V2_API}/custom-dash/amazon-kpis/context`, commonFiltersValue.value)
                .then(res => {
                    if (!res.data?.length)
                        amazonPPKpisIsEmpty.value = true
                    data.value = res.data
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value
    }
}